import React from "react";
import { Routes, Route } from "react-router-dom";
import { connect } from "react-redux";
import NotFoundPage from "../pages/NotFoundPage";
import SignUp from "../pages/SignUp";
import SignIn from "../pages/SignIn";
import Home from "../pages/Home";
import PostTask from "../pages/PostTask";
import UserTasks from "../pages/UserTasks";
import BrowseTasks from "../pages/BrowseTasks";
import ListingDetails from "../pages/ListingDetails";
import Chat from "../pages/Chat";
import SignOut from "../pages/SignOut";
import Account from "../pages/Account";
import TaskPage from "../pages/TaskPage";

// import Favorites from "../pages/Favourites";
// import ChatMessenger from "../pages/ChatMessenger";
import Search from "../pages/Search";
import YourListings from "../pages/YourListings";
import UserProfilePage from "../pages/UserProfilePage";
// import EditListing from "../pages/EditListing";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import ResetPasswordWithToken from "../pages/ResetPasswordWithToken";
import VerifyEmail from "../pages/VerifyEmail";
import HowItWorks from "../pages/HowItWorks";
import SafetyTips from "../pages/SafetyTips";
import { ProtectedRoute } from "./helpers";
import EmailConfirmation from "../pages/EmailConfirmation";
import ManageTaskPage from "../pages/ManageTask";
import Onboarding from "../pages/Onboarding";

function Paths(props) {
  const { history } = props;
  return (
    <Routes>
      <Route path="/" exact element={<Home />} history={history} />
      <Route path="/home" exact element={<Home />} />
      <Route path="/signup" exact element={<SignUp />} />
      <Route path="/signin" exact element={<SignIn />} />
      <Route 
        path="/onboarding" 
        exact 
        element={
          <ProtectedRoute user={props.state.user} redirectPath="/signin">
            <Onboarding />
          </ProtectedRoute>
        } 
      />
      <Route path="/howitworks" exact element={<HowItWorks />} />

      <Route path="/tasks" exact element={<BrowseTasks />} />
      <Route
        path="/posttask"
        exact
        element={
          <ProtectedRoute user={props.state.user} redirectPath="/signin">
            <PostTask />
          </ProtectedRoute>
        }
      />
      <Route
        path="/edit/task/:taskId"
        exact
        element={
          <ProtectedRoute user={props.state.user} redirectPath="/signin">
            <PostTask />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tasks/:taskId/manage"
        exact
        element={
          <ProtectedRoute user={props.state.user} redirectPath="/signin">
            <ManageTaskPage />
          </ProtectedRoute>
        }
      />
      <Route path="/tasks/:id" exact element={<TaskPage />} />
      <Route path="/users/:id" element={<UserProfilePage />} />
      <Route
        path="/dashboard"
        exact
        element={
          <ProtectedRoute user={props.state.user} redirectPath="/signin">
            <UserTasks />
          </ProtectedRoute>
        }
      />
      <Route
        path="/account"
        exact
        element={
          <ProtectedRoute user={props.state.user} redirectPath="/signin">
            <Account />
          </ProtectedRoute>
        }
      />
      <Route path="/listing/details/:id" exact element={<ListingDetails />} />
      <Route path="/search" exact element={<Search />} />
      <Route path="/listings" exact element={<YourListings />} />
      {/* <Route
        path="/edit/"
        exact
        element={
          <ProtectedRoute user={props.state.user} redirectPath="/signin">
            <EditListing />
          </ProtectedRoute>
        }
      /> */}

      {/* <Route
        path="/favourites"
        exact
        element={
          <ProtectedRoute user={props.state.user} redirectPath="/signin">
            <Favorites />
          </ProtectedRoute>
        }
      /> */}

      {/* <Route
        path="/inbox/message/:id"
        exact
        element={
          <ProtectedRoute user={props.state.user} redirectPath="/signin">
            <ChatMessenger />
          </ProtectedRoute>
        }
      /> */}

      <Route
        path="/chat"
        element={
          <ProtectedRoute user={props.state.user} redirectPath="/signin">
            <Chat />
          </ProtectedRoute>
        }
      />
      <Route
        path="/chat/:conversationId"
        element={
          <ProtectedRoute user={props.state.user} redirectPath="/signin">
            <Chat />
          </ProtectedRoute>
        }
      />

      <Route path="/signout" exact element={<SignOut />} />
      <Route path="/password/reset/start" exact element={<ForgotPassword />} />
      <Route path="/password/reset" exact element={<ResetPasswordWithToken />} />
      <Route path="/password/reset/done" element={<ResetPassword />} />
      <Route path="/verify" exact element={<VerifyEmail />} />
      <Route path="/email/confirmation" exact element={<EmailConfirmation />} />
      <Route path="/safety" exact element={<SafetyTips />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps, null)(Paths);

// Used this article as reference:
// https://medium.com/javascript-in-plain-english/routing-and-navigation-in-react-cffc26e8a389
// https://stackoverflow.com/questions/37696391/multiple-params-with-react-router
